import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { OPERATION_MACHINE } from '../types/operation-machine.js';
/**
 * Descriptor for OperationMachine (Máquina prevista de Operação).
 * Subcollection: org/{orgId}/operation/{operationId}/operationMachine
 *
 * Resolve repository with context: { orgId, operationId }.
 */
export const operationMachineDescriptor = {
    name: OPERATION_MACHINE,
    label: 'Máquina prevista da Operação',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/operation/{operationId}/operationMachine',
    pathPatternKeys: {
        orgId: 'string',
        operationId: 'string',
    },
    version: 1,
    description: 'Máquina e tempos esperados de operação/setup por operação',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique operation-machine identifier',
        },
        {
            name: 'machineId',
            label: 'Máquina',
            type: 'string',
            required: true,
            description: 'Reference to the machine for this operation',
        },
        {
            name: 'expectedOperationTime',
            label: 'Tempo de operação esperado',
            type: 'number',
            required: false,
            description: 'Expected operation time in milliseconds (0..MAX_DURATION_MS; null = not informed)',
        },
        {
            name: 'expectedSetupTime',
            label: 'Tempo de setup esperado',
            type: 'number',
            required: false,
            description: 'Expected setup time in milliseconds (0..MAX_DURATION_MS; null = not informed)',
        },
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        {
            fieldName: 'machineId',
            targetEntity: 'Machine',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Máquina vinculada à operação',
        },
        ...AUDIT_FOREIGN_KEYS,
    ],
};
//# sourceMappingURL=operation-machine.descriptor.js.map